export default __webpack_public_path__ + "static/aboutBadge-11d070b0c040ff63a5d430538666fe9b.png";